import React from 'react';
import { withTranslation, WithTranslation } from '@wix/wix-i18n-config';
import s from './Feature.scss';
import Check from '../../../../icons/dist/components/check';

export interface FeatureProps extends WithTranslation {
  description: string;
}

class Feature extends React.Component<FeatureProps> {
  render() {
    const { description, t } = this.props;

    return (
      <div className={s.root} data-hook="feature">
        <div className={s.check} data-hook="feature-check">
          <Check size="11px" color="#3370fb" />
        </div>
        <div className={s.description} data-hook="feature-description">
          {t(description)}
        </div>
      </div>
    );
  }
}

export default withTranslation()(Feature);
